export default "__VITE_ASSET__dbe584e7__"